<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000">THE WORLD'S</h1>
<h1 class="calibre1" id="pgepubid00001">GREATEST</h1>
<h1 class="calibre1" id="pgepubid00002">BOOKS</h1>
<h2 class="sigilnotintoc" id="pgepubid00003">JOINT EDITORS</h2>
<h3 class="sigilnotintoc1" id="pgepubid00004">ARTHUR MEE</h3>
<h4 class="sigilnotintoc2" id="pgepubid00005">Editor and Founder of the Book of Knowledge</h4>
<h3 class="sigilnotintoc1" id="pgepubid00006">J. A. HAMMERTON</h3>
<h4 class="sigilnotintoc2" id="pgepubid00007">Editor of Harmsworth's Universal Encyclopaedia</h4>
<h3 class="sigilnotintoc1" id="pgepubid00008">VOL. III</h3>
<h3 class="sigilnotintoc1" id="pgepubid00009">FICTION</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?ad5a56f4